import React, { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Loader2 } from 'lucide-react';

const REFERRAL_KEY = 'maarivil_ref_code';

const ReferralRedirect = () => {
  const { code } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    const clean = (code || '').toString().toLowerCase().replace(/[^a-z0-9]/g, '');
    if (clean) {
      try { localStorage.setItem(REFERRAL_KEY, clean); } catch (_e) { /* ignore */ }
    }
    navigate(`/register?ref=${encodeURIComponent(clean)}`, { replace: true });
  }, [code, navigate]);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center text-slate-200">
      <Loader2 className="h-10 w-10 animate-spin text-fuchsia-400" />
      <p className="mt-6 font-display text-xl">Preparing your invite…</p>
    </div>
  );
};

export default ReferralRedirect;
